import { CoreCOMService } from "./com.service";
import { environment } from "../../../environments/environment";
import { EnvDir, FileSystemDefault } from "./com/comEnvironmentFileSystem";
import Utils from "../shared/utils";
import { ContentType, ImageWidthSizes, YourAPPProductType } from "../shared/contentTypes";
import { Observable, Subscriber } from "rxjs";

/** UAPP Video Access Service*/
export class CoreVideoService {
  // momentan keine Videos im Store

  // urls zu den standart bildern
  public static get errorImageURL(): string {
    return FileSystemDefault.CreatePathForFile("custom/image/image_error.svg", EnvDir.Assets);
  }

  /** static cache for showed videos (it reduce the time for checking the local files)
   * nur lokal gehalten, wird nach dem neustart der App neu zusammengestellt
   */
  private static _videoCache: { [key: string]: string } = {};

  /** UAPP Image Access Service */
  constructor(private _coreCOMService: CoreCOMService) { }

  /** Gets a Url to get the Image (it try to read image from local storage)
   * @param path z.B. "0/id_name_orientation/20010101/0"
   */
  public getURLByPath(path: string): Observable<string> {
    const me = this;
    const paths = path.split("/");
    const contentType = parseInt(paths[0], 10);
    const imageKey = paths[1];
    const image_change_at_ymd = parseInt(paths[2], 10);
    const image_change_at_hms = parseInt(paths[3], 10);
    return me.getURL(
      contentType,
      imageKey,
      image_change_at_ymd,
      image_change_at_hms
    );
  }

  /** Gets a Url to get the Video
   * @param contentType z.B. 0 = "news"
   * @param videoKey z.B. "id_name_orientation"
   * @param video_change_at_ymd
   * @param video_change_at_hms
   */
  public getURL(
    contentType: ContentType,
    videoKey: string,
    video_change_at_ymd: number,
    video_change_at_hms: number
  ): Observable<string> {
    const me = this;
    const cachedVideoKey =
      contentType +
      "_" +
      videoKey +
      "_" +
      video_change_at_ymd +
      "_" +
      video_change_at_hms;
    const cachedVideoUri = CoreVideoService._videoCache[cachedVideoKey];

    const GetVideoUri = (): string => {
      let width: number = 0;
      // Zurückfallen auf Viewport Breite
      if (this._coreCOMService.environment.client.isMobile) {
        width = Utils.GetViewInnerWidth(); // oder GetPhysicalScreenWidth damit hätte man die mögliche größe des Browsers
      } else {
        width = Utils.GetAPPLogicalWidth(ImageWidthSizes.Size3); // Browser ist limitiert durch APPBreite (ohne möglichen Rand)
      }

      const RequestUri =
        "?type=" +
        contentType +
        "&file=" +
        encodeURIComponent(videoKey) +
        "&width=" +
        encodeURIComponent(width.toString()) +
        "&v=" +
        video_change_at_ymd +
        "_" +
        video_change_at_hms; // version, damit es auch neu geladen wird und nicht der der browser cache
      return environment.ImageServerURI + RequestUri; // ImageServerURI weil die Videos momentan wie Bilder behandelt werden
    };

    const SetVideoUri = (
      observer: Subscriber<string>,
      newVideoUri: string,
      cacheNewVideo: boolean
    ) => {
      // chenge only if the image is a other
      if (newVideoUri != cachedVideoUri) {
        // cache the new uri
        if (cacheNewVideo) {
          CoreVideoService._videoCache[cachedVideoUri] = newVideoUri;
        }
        observer.next(newVideoUri);
      }
    };

    return new Observable<string>((observer) => {
      // use cached image if exists
      if (cachedVideoUri) {
        observer.next(cachedVideoUri);
        observer.complete(); // it is a local image, deeper search is not need
        return; // break here after complete
      }

      SetVideoUri(observer, GetVideoUri(), true);
      observer.complete();
    });
  }
}
